import React, { useState } from 'react';
import { ERoutes } from '../types';
import { getRoute, getRoutesByGroupId } from '../helpers';

// import '../../assets/scss/pages/makeup.scss'

import DefaultLayout from '../layouts/DefaultLayout';

const Makeup: React.FC<any> = (props) => {

  const [route] = useState(getRoute(ERoutes.Makeup))
  const [navGroups] = useState(route?.navGroups?.map(group => {
    return { ...group, routes: getRoutesByGroupId(group.id) }
  }))

  return (
    <DefaultLayout
      {...props}
      route={route}
      navGroups={navGroups}
      title='奉仕活動｜第2750地区東京中央ロータリークラブ'
    >

      MakeUp

    </DefaultLayout>
  );
};

export default Makeup;
